
















































import "material-icons/iconfont/material-icons.css";
import Vue from "vue";
import {
  VBtn,
  VIcon,
  VMenu,
  VList,
  VListItem,
  VListItemTitle,
  VDivider,
  VTooltip
} from "vuetify/lib";
import AccountDropdownMenuItems from "../AccountDropdownMenuItems.vue";

export default Vue.extend({
  components: {
    VBtn,
    VIcon,
    VMenu,
    VList,
    VListItem,
    VListItemTitle,
    VDivider,
    VTooltip,
    AccountDropdownMenuItems
  },
  data() {
    return {
      email: "",
      name: "",
      auth: null
    };
  },
  mounted() {
    this.$set(this, "auth", this.$vtrs);
  },
  methods: {
    async logout() {
      await this.$vtrs.logout();
    }
  },
  watch: {
    "auth.authenticated": {
      handler: function() {
        if (this.$vtrs.authenticated === true && this.auth !== null) {
          this.email = this.$vtrs.userInfo?.emailAddress;
          this.name = this.$vtrs.userInfo?.userFullName;
        }
      },
      deep: true
    }
  }
});
